<!--
 * @Author: 李朋飞
 * @Date: 2021-12-09 10:06:09
 * @LastEditTime: 2021-12-20 11:13:53
 * @Description: 步骤条
-->
<template>
  <div class="l_steps">
    <div class="l_steps_main">
      <div 
        class="l_steps_main_card"
        v-for="(item, index) in stepsList"
        :key="index"
        :style="{'width': `${(100 / stepsList.length)}%`}"
      >
        <div 
          :class="`l_steps_main_card_line_left ${Number(active) >= index ? 'l_steps_main_card_line_yellow' : ''}`" 
          v-if="index != 0"
        ></div>
        <div 
          :class="
            `l_steps_main_card_title ${Number(active) >= index ? 'l_steps_main_card_title_black' : ''}`"
        >
          {{item.title}}
        </div>
        <i v-if="Number(active) >= index" :class="item.iconb" style="margin: 10px 0px;width: 46px;height: 46px;"></i>
        <i v-else :class="item.icon" style="margin: 10px 0px;width: 46px;height: 46px;"></i>
        <div class="l_steps_main_card_description">{{item.description}}</div>
        <div 
          :class="`l_steps_main_card_line_right ${Number(active) > index ? 'l_steps_main_card_line_yellow' : ''}`" 
          v-if="index != (stepsList.length - 1)"
        >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    stepsList: { // 步骤条数据
      type: Array,
      default: () => {
        return [];
      }
    },
    active: { // 当前选中的
      type: [Number, String],
      default: 0
    },
  },
  data() {
    return{

    }
  }
}
</script>
<style lang='scss' scoped>
.l_steps{
  width: 100%;
  .l_steps_main{
    width: 100%;
    display: flex;
    align-items: flex-start;
    .l_steps_main_card{
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .l_steps_main_card_title{
        font-size: 18px;
        color: #CCCCCC;
        font-weight: bold;
      }
      .l_steps_main_card_title_yellow{
        color: #409DFE;
      }
      .l_steps_main_card_title_black{
        color: #333333;
      }
      .l_steps_main_card_description{
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
      .l_steps_main_card_line_left{
        position: absolute;
        left: 0;
        right: calc(50% + 30px);
        border: #CCCCCC 1px dashed;
        top: 50px;
      }
      .l_steps_main_card_line_right{
        position: absolute;
        right: 2px;
        left: calc(50% + 30px);
        border: #CCCCCC 1px dashed;
        top: 50px;
      }
      .l_steps_main_card_line_yellow{
        border: #409DFE 1px dashed !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Steps/Steps.vue